<template>
  <div id="verified">
    <div class="card-other">
      <h4>
        尊敬的代理商，为了您更方便的提现佣金，请用微信绑定收款账户 谢谢您的配合！
      </h4>
      <div class="main">
        <van-cell-group>
          <van-field
            v-model="verifiedInfo.accountName"
            clearable
            left-icon="info-o"
            placeholder="请输入后台账号"
            :disabled="isFirst == 2"
          />

          <van-field
            v-model="verifiedInfo.pwd"
            clearable
            left-icon="user-o"
            placeholder="请输入后台密码"
            :disabled="isFirst == 2"
          />
        </van-cell-group>
        <div class="btnOuter">
          <mt-button
            type="primary"
            size="large"
            @click.prevent="sureVerifiedHandler"
            :disabled="disabledFlag"
            >确定</mt-button
          >
        </div>
        <div
          style="color: red; padding-top: 20px; line-height: 24px"
          v-if="isFirst != 2"
        >
          <p>温馨提示：</p>
          <p>
            1、请确保你的账号密码正确，或者无法绑定！
          </p>
           <p>
            2、绑定成功后，如需要重新绑定 请再次扫码登录！
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { wxRequest, verified } from "@/api/user";
import { Dialog } from "vant";
export default {
  data() {
    return {
      qianhairealname:false,
      state: "",
      supplierTypeCode: "",
      verifiedInfo: {
        accountName: "",
        pwd: "",
        mobile: "",
        smsCode: "",
        wxCode:""
      },
      disabledFlag: false,
      existFrontImg: false,
      existBackImg: false,
      existHandImg: false,
      frontImgUrl: "",
      backImgUrl: "",
      handImgUrl: "",
      realNameCard: -1, //需弹实名的卡
      isFirst: 0,
    };
  },
  methods: {
       getSmsCode(){
            var data = {
                userPhone: this.verifiedInfo.mobile
            }
            wxRequest("xxtx/wx/bindPhone/sms/code", data, "post").then(res => {
                if(res.data.code == 200){
                    var n = 60;
                    this.btnTxt = '重新发送' + n +'s';
                    let timer = window.setInterval(() => {   
                        n--;                     
                        this.btnTxt = '重新发送' + n +'s';
                        if(n < 1){
                            window.clearInterval(timer);
                            this.btnTxt = '发送验证码';
                        }
                    },1000)
                    Dialog.alert({title: "提示", message:"发送成功"});
                }else{
                    Dialog.alert({title: "提示", message:res.data.message});
                }
            })
        },
    getVerifiedInfoHandler() {
      var data = {
        iccid: localStorage.getItem("iccid"),
      };
      // wxRequest("wxAuth/list", data, "post").then(res => {  //查照片的接口
      //     if(res.data.code == 200 && res.data.data){
      //         for(var key in this.verifiedInfo){
      //             this.verifiedInfo[key] = res.data.data[key];
      //             this.existFrontImg = true;
      //             this.existBackImg = true;
      //             this.existHandImg = true;
      //             this.frontImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.headerUrl
      //             this.backImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.backHeaderUrl
      //             this.handImgUrl = process.env.VUE_APP_IMG_URL + '/' + res.data.data.handheldUrls
      //         }
      //     }
      // })
      wxRequest("bindPhone/phone/info/iccid", data, "post").then((res) => {
        if (res.data.code == 200 && res.data.data) {
          for (var key in this.verifiedInfo) {
            this.verifiedInfo[key] = res.data.data[key];
          }
        }
      });
    },
    sureVerifiedHandler() {
      wxRequest("xxtx/wx/sysUser/bind/wx/openid", this.verifiedInfo, "post").then((res) => {
        if (res.data.code == 200) {
             Dialog.alert({title: "提示", message:"绑定成功！"});
        } else{
           Dialog.alert({title: "提示", message:res.data.message});
        }
      });
    },
     //获取url参数
        getQueryVariable(variable){
           var query = window.location.search.substring(1);
           var vars = query.split("&");
           for (var i=0;i<vars.length;i++) {
                   var pair = vars[i].split("=");
                   if(pair[0] == variable){return pair[1];}
           }
           return false;
        },
    //支付实名
    payRealName() {
      let fd = new FormData();
      fd.append("iccid", this.verifiedInfo.iccid);
      let _this = this;
      wxRequest("order/bind/phone", fd, "post").then((res) => {
        let param = res.data.data.param;
        WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            _this.$router.push({
              path: "/user/home",
            });
          }
        });
      });
    },
  },
  created() {
      var source = this.getQueryVariable('source') ? this.getQueryVariable('source') : process.env.VUE_APP_APPID;
        localStorage.setItem('appid', source);
        localStorage.setItem('isHeadquarterAppid', false);
        var appid  = source ? source : process.env.VUE_APP_APPID;

        console.log(appid)
        var redirectUrl = window.location.href;   
        var index = redirectUrl.indexOf('code');
        redirectUrl = encodeURIComponent(redirectUrl);
        if(index < 0){
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
        }else{
            var search = window.location.search;
            console.log('search',search);
            var startIndex = search.indexOf('code');
            var endIndex = search.indexOf('&', startIndex);
            var str = search.slice(startIndex, endIndex);
            var code = str.slice(str.indexOf('=') + 1);
            this.verifiedInfo.wxCode = code;
        }
  },

  mounted() {
   
  },
};
</script>
<style lang="less">
#verified {
  height: 100%;
  h4 {
    color: #fff;
    font-size: 10px;
    background: #26a2ff;
    line-height: 1.5em;
    padding: 6px 3%;
  }
  ul {
        margin: 10px;
        li {
            line-height: 36px;
            padding: 3px 0;
            border-bottom: 1px solid #ffa33a;
            svg {
                vertical-align: middle;
                margin-right: 8px;
            }
            .codeBtn {
                float: right;
                margin-top: 2px;
            }
        }
    }
  .main {
    height: calc(100% - 48px);
    padding: 0 4%;
    form {
      height: 100%;
    }
    .line {
      border-bottom: 1px solid #e5e5e5;
    }
    // .many {
    //     display: flex;
    //     justify-content: space-between;
    //     label {
    //         display: block;
    //         line-height: 36px;
    //     }
    //     .uploadOuter {
    //         position: relative;
    //         display: flex;
    //         justify-content: center;
    //         align-items: center;
    //         width: 48%;
    //         height: 100px;
    //         border: 1px dashed #e5e5e5;
    //         box-sizing: border-box;
    //         input[type=file] {
    //             position: absolute;
    //             top: 0;
    //             width: 0;
    //             width: 100%;
    //             height: 100%;
    //             opacity: 0;
    //         }
    //         img {
    //             width: 100%;
    //             height: 100%;
    //         }
    //     }
    // }
    // .title {
    //     line-height: 28px;
    //     margin-top: 10px;
    // }
    .btnOuter {
      // display: flex;
      // align-items: center;
      // height: calc(100% - 424px;)

      margin-top: 30px;
    }
  }

  .card-dianxin {
    width: 100%;
    height: 100%;
    h1 {
      font-size: 14px;
      background: #fff;
      line-height: 1.5em;
      padding: 6px 3%;
    }
    .dianxin-iframe {
      width: 100%;
      height: 100%;
    }
  }

  .card-other {
    width: 100%;
    height: 100%;
  }
  input.van-field__control {
    padding-left: 5px;
    line-height: 24px;
  }
}
</style>
